
// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and 
// compiles into the necessary css files
require('../scss/index.scss');

require('./components/navigation.js');
require('./components/social-share.js');
require('./components/toggle-element.js');
require('./components/calculator.js');

require('./components/homepage-banner-rotate.js');

require('./components/Transactions.js');
require('./global/effects.js');



// WEBPACK FOOTER //
// ./site/js/index.js